import { connect } from "react-redux";

function Dashboard() {
    return (
        <div className="main-container">
            Dashboard Content
        </div>
    );
}

const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps, {
    
})(Dashboard);
